import React from 'react';
import { motion } from 'framer-motion';
import GlassNav from './components/portfolio/GlassNav';
import MagneticCursor from './components/portfolio/MagneticCursor';
import InteractiveBackground from './components/portfolio/InteractiveBackground';
import HeroSection from './components/portfolio/HeroSection';
import BentoProjects from './components/portfolio/BentoProjects';
import SkillsCloud from './components/portfolio/SkillsCloud';
import ExperienceTimeline from './components/portfolio/ExperienceTimeline';
import ContactSection from './components/portfolio/ContactSection';
import FooterBar from './components/portfolio/FooterBar';

function App() {
  return (
    <div className="relative min-h-screen overflow-x-clip text-slate-100">
      <InteractiveBackground />
      <MagneticCursor />
      <GlassNav />

      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <HeroSection />
        <BentoProjects />
        <SkillsCloud />
        <ExperienceTimeline />
        <ContactSection />
      </motion.main>

      <FooterBar />
    </div>
  );
}

export default App;
